module.exports = __webpack_public_path__ + "img/showcase-hero-bg.f72018b0.jpg";